//信件详情界面
const EmailDetailGiftItem = require("./EmailDetailGiftItem");
let EmailDetailPanel = xClass("EmailDetailPanel", BasePanel, function () {
    return cc.CSLoader.createNode(`cocos/mail_mail_content.csb`);
})

const RES = ["packed/EmailDetailPanel.pack"];

EmailDetailPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask);
}

EmailDetailPanel.prototype.ctor = function (data = {}) {
    let self = this;
    BasePanel.prototype.ctor.call(self);
    self.data = data;
    self.EmailMgr = EmailManager.getInstance();
    self.fitScreen();
    self.initUI();
    self.popup();
}

EmailDetailPanel.prototype.initUI = function () {
    let self = this;
    let title = self.getChildByName("label1");
    let timeL = self.getChildByName("label2");
    let sendL = self.getChildByName("label3");

    let mail_btn_del = self.getChildByName("mail_btn_del");
    let com_close_red = self.getChildByName("com_close_red");
    let lib_btn_green_normal4 = self.getChildByName("lib_btn_green_normal4");
    let content_bg = self.getChildByName("content_bg");
    let sep_line = content_bg.getChildByName("sep_line");
    //
    sendL.setString("发件人：" + self.data.senderName);
    title.setString(self.data.mailTitle);
    timeL.setString("时间：" + formatDate(new Date(self.data.addTs), 'yyyy/MM/dd'));
    //
    const mailId = self.data ? self.data.mailId : null;
    //
    quickBuildUIButton(com_close_red, function () {
        if (self.isBusy) return;
        self.isBusy = true;
        self.onClose();
        //
        let type = self.data.acceptFlag == 1 ? 2 : 1;
        let s_time = null;
        if (type == 1) {
            s_time = self.EmailMgr.getDcSTime(self.data.expireTs);
        }
        self.EmailMgr.dcSimple("message_click", {
            click_type: "close",
            session: self.EmailMgr.dcSession,
            sub_id: mailId,
            type,
            s_time,
        });
    });

    quickBuildUIButton(mail_btn_del, function () {
        if (self.isBusy && mailId && self.data.deletableFlag) return;
        self.isBusy = true;
        //
        self.EmailMgr.mailDelete(mailId).then(function (evt) {
            self.EmailMgr.delMail(mailId);
            self.EmailMgr.refreshMails();
            self.onClose();
            //
            self.EmailMgr.dcSimple("message_click", {
                click_type: "delete",
                session: self.EmailMgr.dcSession,
                sub_id: mailId,
            });
        }).catch(function (err) {
            if (self.EmailMgr.needDelMail(err)) {
                self.onClose();
            } else {
                self.isBusy = false;
            }
            console.error("EmailDetailPanel - mailAccept", err);
        });
    });

    quickBuildUIButton(lib_btn_green_normal4, function () {
        if (self.isBusy && mailId) return;
        self.isBusy = true;
        //
        self.EmailMgr.mailAccept(mailId).then(function (evt) {
            self.isBusy = false;
            mail_btn_del.setVisible(true);
            lib_btn_green_normal4.setVisible(false);
            self.EmailMgr.refreshMails();
            //
            let rewards = evt.rewards;
            ActivityGetRewardsPanel.show({
                type: 1,
                add_model: "mail",
                rewardList: rewards,
                tobagAni: true,
                title: "normal",
                closeCb: () => {
                }
            })
            //
            let reward = "";
            table.each(rewards, function (item) {
                if (item) {
                    reward += item.itemId + "_" + item.num + ";";
                }
            })
            //
            self.EmailMgr.dcSimple("message_click", {
                click_type: "reward",
                session: self.EmailMgr.dcSession,
                sub_id: mailId,
                reward,
            });
        }).catch(function (err) {
            if (self.EmailMgr.needDelMail(err)) {
                self.onClose();
            } else {
                self.isBusy = false;
            }
            console.error("EmailDetailPanel - mailAccept", err);
        });
    });
    //
    if (self.data.rewardFlag == 1 && !self.data.acceptFlag) {
        lib_btn_green_normal4.setVisible(true);
    } else {
        lib_btn_green_normal4.setVisible(false);
    }
    mail_btn_del.setVisible(!!self.data.deletableFlag);
    //创建奖励节点
    const interval = 132;
    const scrollViewWidth = 516;
    let isShowReward = false;
    if (self.data.rewardItems && $len(self.data.rewardItems)) {
        sep_line.setVisible(true);
        isShowReward = true;
        //
        let scrollView = ccui.ScrollView.create();
        scrollView.setAnchorPoint(0.5, 1);
        scrollView.setDirection(ccui.ScrollViewDir.vertical);
        scrollView.setContentSize(scrollViewWidth, 225);
        scrollView.setClippingEnabled(true);
        scrollView.setBounceEnabled(true);
        content_bg.addChild(scrollView);
        scrollView.setPosition(content_bg.width / 2, 245);
        //
        const len = $len(self.data.rewardItems);
        const maxHeight = Math.max(Math.ceil(len / 4) * interval, scrollView.height);
        for (let i = 0; i < len; i++) {
            let reward = self.data.rewardItems[i + 1];
            if (reward) {
                let item = EmailDetailGiftItem.create();
                item.initData(reward, !!self.data.acceptFlag);
                scrollView.addChild(item);
                item.setPosition((i % 4) * interval + item.width / 2, maxHeight - item.height / 2 - Math.floor(i / 4) * interval);
            }
        }
        scrollView.setInnerContainerSize(cc.size(scrollViewWidth, maxHeight));
    } else {
        sep_line.setVisible(false);
    }
    //创建邮件文本内容
    let scrollView = ccui.ScrollView.create();
    scrollView.setAnchorPoint(0.5, 1);
    scrollView.setDirection(ccui.ScrollViewDir.vertical);
    scrollView.setContentSize(scrollViewWidth, isShowReward ? 225 : 480);
    scrollView.setClippingEnabled(true);
    scrollView.setBounceEnabled(true);
    content_bg.addChild(scrollView);
    scrollView.setPosition(content_bg.width / 2, content_bg.height - 17);
    //
    let textTip = cc.LabelTTF.create(self.data.mailContent, null, 28);
    textTip.setColor(cc.c4b(122, 51, 32, 255));
    textTip.setAnchorPoint(0, 1);
    textTip.setLineHeight(40);
    textTip.setDimensions(scrollViewWidth, 0);
    textTip.setPosition(0, Math.max(textTip.height, scrollView.height));
    scrollView.addChild(textTip);
    scrollView.setInnerContainerSize(cc.size(scrollViewWidth, textTip.height));
}

EmailDetailPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this;
    BasePanel.prototype.onClose.call(self, callback, arg);
}

EmailDetailPanel.prototype.onCleanup = function () {
    let self = this;
    //
    ResManager.release(RES);
}

EmailDetailPanel.prototype.fitScreen = function () {
    let self = this;
    const scaleY = display.height / GamePlayConfig_Design_Height;
    const scaleX = display.width / GamePlayConfig_Design_Width;
    if (scaleY / scaleX > 1) {

    } else {
        let scale = Math.min(scaleX, scaleY);
        self._scale = scale;
        self.setScale(self._scale);
    }
}

module.exports = EmailDetailPanel;